<template>
  <div>
    <section class="ptb-100" style="padding-top: 40px;" v-if="toolCateList && toolCateList.length">
       <div class="container">
        <el-row :gutter="20">
          <el-col :span="3">
            <div style="position: fixed; left: 6%; background-color: #FFF;">
              <el-tabs tab-position="left" @tab-click='tabClick'>
                <el-tab-pane :label="toolCate.title" v-for="(toolCate, index) in toolCateList"
                  :key="index"
                  :name="toolCate.id+''">
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="20" style="margin-bottom: 10px;">
              <el-col :span="8">
                <xy-track-form/>
              </el-col>
              <el-col :span="8">
                <xy-price-form/>
              </el-col>
              <el-col :span="8">
                 <xy-login-form/>
              </el-col>
            </el-row>
            <el-input placeholder="搜索你想要的工具" v-model="toolName" clearable @input="debouncedHandleSearch" @keydown.enter="getToolCate()" style="width: 102%">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-row :gutter="20" style="padding-top: 10px;">
              <el-col class="col20" :span="20">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <a :id="toolCateList[0].id" :href="'#'+toolCateList[0].id" style="color: rgb(0, 70, 185); font-size: 16px; font-weight: 500;">{{ toolCateList[0].title }}</a>
                  </div>
                  <div class="tool-list">
                    <div class="tool-list-item" v-for="(tool, index) in toolCateList[0].tools" :key="index" @click="openNewWindow(tool)">
                      <div class="tool-list-item__logo">
                        <img :alt="tool.title" :src="tool.icon && tool.icon.length ? tool.icon : 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" width="48" height="48" style="height: 48px;"></div>
                        <div class="tool-list-item__title">
                          <p>{{ tool.title }}</p>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col class="col4" :span="4">
                  <div class="time-list-card">
                    <div class="time-item" v-for="(zoon, index) in zoonList" :key="index">
                      <img width="24" height="16" :src="zoon.icon">
                      <span style="padding-left: 10px; padding-right: 10px; ">{{ zoon.contry }}</span>
                      {{ zoon.time }}
                    </div>
                  </div>
                </el-col>
            </el-row>
            <el-row v-for="(toolCate, cateIndex) in toolCateList" :key="cateIndex" v-if="toolCate.tools && toolCate.tools.length && cateIndex > 0">
              <el-col :span="24">
                <div class="tool-context top0" id="1">
                  <a :id="toolCate.id" :href="'#'+toolCate.id" class="tool-title">{{ toolCate.title }}</a>
                  <div class="tool-hr"></div>
                  <div class="tool-list tool-list-2" style="height: auto;">
                    <div style="height: auto;" v-for="(tool, index) in toolCate.tools" :key="index" @click="openNewWindow(tool)">
                      <div class="tool-item tool-item-type2">
                        <div class="tool-item-main">
                          <img :src="tool.icon && tool.icon.length ? tool.icon : 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" width="32" height="32" style="object-fit: scale-down;">
                          <div class="item-type-2">
                            <span class="item-span-title">{{ tool.title }}</span>
                            <div style="height: 20px;">
                              <div class="item-span-desc">
                                <p data-v-4f63f5ee="">{{ tool.info }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </section>
    <section class="ptb-100" style="padding-top: 40px; height: 800px;" v-else>
       <i class="el-icon-loading" style="color: #409EFF; font-size: 80px; position: relative; left: 40%;"/>
    </section>
    <div class="rightMenu">
      <div class="item weixin-show flex_col_center2" v-for="(rightMenu, index) in rightMenuList" :key="index">
        <el-popover
          :ref="'popover-'+rightMenu.id"
          placement="left-start"
          :title="rightMenu.title"
          width="200"
          trigger="hover">
          <div v-html="rightMenu.content"/>
          <div class="flex_col_center2" slot="reference">
            <i class="fa" style="font-size: 24px;">
              <img :src="rightMenu.icon" aria-hidden="true" class="fa icon-kefu iconItemDefault"/>
            </i>
            <div class="maR_t8"> {{ rightMenu.title }}</div>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- 跳转到定制页面 -->
    <router-link id="toPage" :to="{path:'page'}"  target="_blank" style="display:none;">跳转到详情页</router-link>
  </div>
</template>
<script>
import XyTrackForm from './xy-track-form'
import XyPriceForm from './xy-price-form'
import XyLoginForm from './xy-login-form'
import moment from 'moment-timezone';
import {listToolCate, listRightMenu, listZoon, listToolIcon, listRightMenuIcon} from '../api/index'
export default {
  name: 'home',
  data () {
    return {
      toolName: '',
      // 查询表单
      dataForm: {
        orderBy: '1'
      },
      toolCateList: [],
      zoonList: [],
      rightMenuList: [],
      bills: '',
    }
  },
  components: {
    XyTrackForm, XyPriceForm, XyLoginForm
  },
  computed:{
  },
  created(){
    this.init()
    this.debouncedHandleSearch = debounce(this.getToolCate, 500); // 1000毫秒内只执行一次
  },
  methods: {
    // 初始化
    init () {
      this.$nextTick(() => {
        this.$parent.isShowHotelBanner = true
        this.$parent.isShowHotelFooter = true
        this.$parent.menuStyle = ''
        this.getToolCate()
        this.getZoon()
        this.getRightMenu()
        this.updateTimes()
        setInterval(() => this.updateTimes(), 1000)
      })
    },
    async getToolCate () {
      let body = {'title': this.toolName}
      let response = await listToolCate(body)
      if (response && response.code === 0 && response.data) {
        this.toolCateList = response.data
        this.getToolIcon();
      } else {
        this.$message.error(response.msg)
      }
    },
    async getToolIcon () {
      let response = await listToolIcon()
      if (response && response.code === 0 && response.data) {
        this.toolCateList.forEach(item => {
          if(item.tools && item.tools.length) {
            item.tools.forEach(tool => {
              let find = response.data.find((a)=>a.id == tool.id)
              if(find) {
                tool.icon = find.icon
              }
            })
          }
        })
      }
    },
    async getZoon () {
      let response = await listZoon()
      if (response && response.code === 0 && response.data) {
        this.zoonList = response.data
      } else {
        this.$message.error(response.msg)
      }
    },
    async getRightMenu() {
      let response = await listRightMenu()
      if (response && response.code === 0 && response.data) {
        this.rightMenuList = response.data
        this.getRightMenuIcon()
      } else {
        this.$message.error(response.msg)
      }
    },
    async getRightMenuIcon () {
      let response = await listRightMenuIcon()
      if (response && response.code === 0 && response.data) {
        this.rightMenuList.forEach(rightMenu => {
          let find = response.data.find((a)=>a.id == rightMenu.id)
          if(find) {
            rightMenu.icon = find.icon
            rightMenu.content = find.content
          }
        })
      }
    },
    // 打开新窗口
    openNewWindow(tool) {
      const jumpType = tool.jumpType
      const url = tool.url
      if(jumpType == 1) {
        if(!url) {
          this.$message.error('请维护url')
          return
        }
        window.open(url, '_blank')
      }
      if(jumpType == 2) {
        localStorage.setItem("toolId", tool.id)
        document.getElementById("toPage").click()
      }
    },
    tabClick(target, action) {
      // window.location.hash= '#'+target.name
      let anchor = target.name
      const el = document.getElementById(anchor);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    // 使用计算属性动态计算各时区的时间
    updateTimes() {
      const now = moment().tz('UTC')
      this.zoonList.forEach(country => {
        country.time =  moment(now).tz(country.zone).format('MM-DD HH:mm:ss')
      })
      this.zoonList = JSON.parse(JSON.stringify(this.zoonList))
    },
    handleSubmit() {
      // 进行表单验证
      if (!this.checkData()) {
        return;
      }
      // 提交表单数据
      const formData = new FormData();
      formData.append('language', 'zh');
      formData.append('bills', this.bills);

      // 使用 fetch 或 axios 发送 POST 请求
      fetch('https://xy56.kingtrans.cn/WebTrack', {
        method: 'POST',
        body: formData,
        target: '_blank'
      })
        .then(response => response.text())
        .then(data => {
          // 处理响应数据
          console.log(data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    checkData() {
      // 实现表单验证逻辑
      const bills = this.bills.split('\n').filter(bill => bill.trim() !== '');
      if (bills.length > 10) {
        this.$message.error('最多只能输入10个运单单号');
        return false;
      }
      return true;
    },
  }
}

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}
</script>
<style lang="scss">
.xy-title {
  height: 30px;
  line-height: 30px;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  border-bottom: 1px #CCC solid;
  margin-bottom: 15px;
  b {
    height: 29px;
    width: 100px;
    display: block;
    border-bottom: 2px #78b6e5 solid;
    color: #0475cc;
    padding-left: 10px;
  } 
}
.button {
  width: 80px;
  height: 14px;
  line-height: 14px;
  background: #78b6e5;
  display: block;
  text-align: center;
  color: #FFF;
  border: 0;
}
/* el 输入框 */
.el-input__inner {
  /* height: 55px; */
  width: 100%;
  color: #1f2b4b;
}
.maR_t8 {
  font-size: 12px;
  font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB, Source Han Sans, Noto Sans CJK Sc, Microsoft YaHei, Microsoft Jhenghei, sans-serif !important;
  color: #333;
  text-align: center;
}
.iconItemDefault {
  width: 32px;
  text-align: right;
  position: relative;
  left: 14px;
  top: 4px;
}
.tool-item-type2:hover {
  box-shadow: rgb(225, 226, 231) 0px 2px 9px 0px;
  color: #409EFF;
  .item-span-title  {
    color: #409EFF;
  }
}

.tool-list {
  display: flex;
  flex-wrap: wrap;
  .tool-list-item:hover {
    box-shadow: rgb(225, 226, 231) 0px 2px 9px 0px;
    color: #409EFF;
    .tool-list-item__title {
      p {
        color: #409EFF;
      }
    }
  }
  .tool-list-item {
    width: 115px;
    padding: 5px 0;
    box-sizing: border-box;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    .tool-list-item__logo{
      display: flex;
      justify-content: center;
    }
    .tool-list-item__title {
      text-align: center;
      margin-top: 16px;
      width: 120px;
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.time-list-card {
  width: 206px;
  height: 320px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
  .time-item {
    flex: 1;
    display: inline-flex;
    align-items: center;
    margin-left: 24px;
    font-size: 13px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #777;
    line-height: 20px
    span {
      padding: 0 8px;
    }
  }
}
.tool-context{
  // width: 1098px;
  width: 102%;
  padding: 16px 24px;
  margin-top: 24px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,.08)
}

.tool-context .tool-title{
    cursor: default;
    font-size: 16px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 24px
}

.tool-context .tool-title-active{
    color: #0046b9
}

.tool-context .tool-hr{
    margin: 16px 0
}

.tool-context .tool-hr:after {
    content: "  ";
    width: 100%;
    height: 1px;
    background: #f0f0f0;
    display: block
}

.tool-context .tool-list{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap
}

.tool-context .tool-list .tool-item{
    width: 196px;
    margin-top: 8px;
    padding: 16px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center
}

.tool-context .tool-list .tool-item i{
    font-size: 16px;
    opacity: 0
}

.tool-context .tool-list .tool-item .img-star{
    opacity: 0
}

.tool-context .tool-list .tool-item .icon-default{
    color: #d0d0d0
}

.tool-context .tool-list .tool-item .icon-active{
    color: #f2cb51
}

.tool-context .tool-list .tool-item img{
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%
}

.tool-context .tool-list .tool-item .item-type-1{
    display: inline-flex;
    width: 104px
}

.tool-context .tool-list .tool-item .item-type-1 span{
    font-size: 14px;
    color: #333;
    line-height: 21px;
    font-family: PingFangSC-Regular,PingFang SC;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.tool-context .tool-list .tool-item .item-type-2{
    display: inline-flex;
    flex-direction: column;
    width: 104px;
    margin: 0 8px
}

.tool-context .tool-list .tool-item .item-type-2 .item-span-title{
    font-size: 14px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.tool-context .tool-list .tool-item .item-type-2 .item-span-desc{
    display: inline-block;
    width: 104px
}

.tool-context .tool-list .tool-item .item-type-2 .item-span-desc p{
    font-size: 13px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #777;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.tool-context .tool-list .tool-item .item-type-2 .item-div-desc{
    display: inline-block;
    width: 104px;
    overflow: hidden
}

.tool-context .tool-list .tool-item .item-type-2 .item-div-desc p{
    padding: 0;
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #777;
    line-height: 17px;
    white-space: nowrap;
    -webkit-animation: wordsLoop-data-v-4f63f5ee 5s linear infinite normal;
    animation: wordsLoop-data-v-4f63f5ee 5s linear infinite normal;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden
}

.message-box-main {
    position: relative
}

.message-box-main .message-box-dialog {
    position: absolute;
    top: 16px;
    right: 73px;
    display: flex;
    align-items: center;
    width: 190px;
    height: 32px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    box-sizing: border-box;
    border-radius: 8px
}

.message-box-main .message-box-dialog p {
    position: relative;
    left: 10px;
    width: 154px;
    font-size: 14px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 20px;
    box-sizing: border-box
}

.message-box-main .message-box-dialog p:hover {
    cursor: pointer;
    color: #0046b9
}

.message-box-main .message-box-dialog i {
    flex: 1;
    position: relative;
    left: 10px;
    font-size: 16px;
    padding: 0 3px
}

.message-box-main .message-box-dialog i:hover {
    cursor: pointer;
    color: #0046b9
}

.message-box-main .message-box-dialog .arrow-icon {
    position: relative;
    right: -10px;
    color: #fff;
    font-size: 12px
}

.message-box .icon1 {
    opacity: 1;
    transition: all 1s
}

.message-box .span-title-icon {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9999;
  right: 0;
  bottom: 124px;
  transition: right .8s;
  padding-right: 8px
}

.rightMenuSmall {
    right: -56px;
    transition: right .8s
}

.rightMenuSmall:hover {
    right: 0;
    transition: right .8s;
    cursor: pointer
}

.rightMenu .item {
    width: 64px;
    height: 64px;
    background: #FFF;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.06);
    border-radius: 8px;
    position: relative;
    margin-top: 8px
}

.rightMenu .item:hover {
    border: 1px solid rgba(0,70,185,.32);
    box-sizing: border-box
}

.rightMenu .item .span-title,.rightMenu .item .top-box .span-title-icon,.rightMenu .span-title,.rightMenu .top-box .item .span-title-icon,.rightMenu .top-box .span-title-icon {
    font-size: 12px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 56px;
    letter-spacing: 1px;
    text-align: center;
    display: block;
    cursor: pointer
}

.rightMenu .span-title-2,.rightMenu .weixin-show .span-title-icon {
    display: block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 15px;
    letter-spacing: 1px;
    padding: 13px 11px 13px 15px;
    cursor: pointer
}

.rightMenu .first-icon,.rightMenu .top-box .icon1,.rightMenu .weixin-show .icon1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer
}

.rightMenu .message-info {
    display: none;
    position: absolute;
    right: 61px;
    top: 5px;
    width: 230px;
    height: 46px;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0,0,0,.1);
    border-radius: 10px
}

.rightMenu .message-info .flex-box {
    display: flex
}

.rightMenu .message-info .flex-box .message-icon {
    padding: 13px 14px
}

.rightMenu .message-info .flex-box .text {
    font-size: 13px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 46px;
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.rightMenu .message-box:hover {
    color: #0046b9;
    cursor: pointer
}

.rightMenu .message-box:hover .icon1 {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu .message-box:hover .span-title-icon {
    opacity: 1;
    display: block;
    transition: all 1s
}

.rightMenu .weixin-show .icon1 {
    opacity: 1;
    transition: all 1s
}

.rightMenu .weixin-show .span-title-icon {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu .weixin-show .weixin-box {
    opacity: 1;
    width: 0;
    height: 0;
    padding: 0;
    position: absolute;
    right: 44px;
    top: -25px;
    border-radius: 8px
}

.rightMenu .weixin-show .weixin-box img {
    position: absolute;
    right: 23px;
    top: 20px;
    width: 0;
    height: 0;
    transition: all .5s;
    z-index: 99999
}

.rightMenu .weixin-show:hover {
    color: #0046b9;
    cursor: pointer
}

.rightMenu .weixin-show:hover .weixin-box {
    opacity: 1;
    box-sizing: border-box
}

.rightMenu .weixin-show:hover .weixin-box,.rightMenu .weixin-show:hover .weixin-box img {
    width: 314px;
    height: 136px;
    transition: all 1s
}

.rightMenu .weixin-show:hover .icon1 {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu .weixin-show:hover .span-title-icon {
    opacity: 1;
    display: block;
    transition: all 1s
}

.rightMenu .top-box {
    position: relative
}

.rightMenu .top-box .icon1 {
    opacity: 1;
    transition: all 1s
}

.rightMenu .top-box .span-title-icon {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu .top-box:hover {
    color: #0046b9;
    cursor: pointer
}

.rightMenu .top-box:hover .icon1 {
    opacity: 0;
    display: none;
    transition: all 1s
}

.rightMenu .top-box:hover .span-title-icon {
    opacity: 1;
    display: block;
    transition: all 1s
}
</style>



// WEBPACK FOOTER //
// Home.vue?36184f3a